import { useMutation, useQueryClient } from '@tanstack/react-query'
import { type MeetingScope, meetingKeys, meetingScopeUrl } from '@/entities/meeting'
import { apiRequest } from '@/shared/api'
import type { FileRef } from '@/shared/lib'

export type CreateMeetingVars = {
  title: string
  when: string
  location?: string
  participants?: string
  url?: string
  notes?: string
  customer_visible?: boolean
  attachments?: FileRef[]
}

// Встреча заводится в контуре проекта или компании — путь решает контур.
// Инвалидация плоская по namespace: встреча проекта видна и в ленте своей
// компании, конкретный список хуку неизвестен.
export function useCreateMeeting(scope: MeetingScope) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (vars: CreateMeetingVars) =>
      apiRequest({ method: 'POST', url: meetingScopeUrl(scope), body: vars }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: meetingKeys.all })
    },
  })
}
